import React from 'react';
import { Modal, Form, Divider } from 'antd';

import DropZone from '@components/controls/DropZone';
import Api from '../../../api';

function UploadContentModal({
  t,
  isOpen,
  toggle,
  onFetch,
  onSubmit,
  onDelete,
}) {
  const [form] = Form.useForm();

  const onCancel = () => {
    toggle();
    form.resetFields();
  };

  return (
    <Modal
      className="upload-modal-content"
      title={t('upload-content')}
      visible={isOpen}
      onCancel={onCancel}
      footer={null}
    >
      <Form onFinish={onSubmit} form={form} name="upload-content">
        <Form.Item className="upload-modal-content__item" name="files">
          <DropZone
            accept=".mp4,.mov,.jpg,.png"
            action={Api.CONTENT_ADD_FILES}
            onRemove={({ response }) =>
              onDelete(response.id, { onSuccess: null })()
            }
            multiple
            onSuccess={onFetch}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default UploadContentModal;
